<template>
    <a-menu style="width: 260px" mode="inline" theme="dark" v-model="selectKey " :open-keys="openKeys">
        <slot v-for="item in menus">
          <a-sub-menu :key="item.name" v-if="item.children && item.children.length && item.meta.isShowChild">
            <span slot="title">
                <a-icon :type="item.meta.icon" />
                <span>{{item.meta.title}}</span>
            </span>
            <slot v-for="list in item.children">
              <a-menu-item :key="list.name" v-if="list.meta.isNav">
                <router-link :to="list.path">{{list.meta.title}}</router-link>
              </a-menu-item>
            </slot>
          </a-sub-menu>
          <a-menu-item :key="item.name" v-else>
            <router-link :to="item.path">
              <a-icon :type="item.meta.icon" /> {{item.meta.title}}
            </router-link>
          </a-menu-item>
        </slot>
      </a-menu>
</template>


<script>
export default {
    computed:{
        menus(){
          let _p = this.$route.path.split('/')[1]
          return this.$router.options.routes.filter(item => item.name == _p)[0].children
        }
    },
    data(){
        return{
            selectKey:[],
            openKeys:[]
        }
    },
    created() {
        this.openKeys = this.menus.filter(item => item.children && item.children.length > 0).map(item => item.name)
        this.getSelectKey(this.$route)
      },
    methods:{
        getSelectKey(router){
          this.menus.forEach(item =>{
            if(item.children && item.children.length && item.meta.isShowChild){
              item.children.forEach(v =>{
                if(router.name.includes(v.name)){
                  this.selectKey = [v.name]
                }
              })
            }else{
              if(router.name.includes(item.name)){
                 this.selectKey = [item.name]
              }
            }
          })
        }
    },
    watch:{
      '$route':function(router){
        this.getSelectKey(router)
      }
    }
}
</script>